import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { loginSms } from '../../../crud/auth.crud';
import { getResponseMessage } from '../../../utils/utils';
import { actions as authActions } from '../../../store/ducks/auth.duck';
import { phoneFormat } from '../utils/phoneFormat';

export const useFetchLoginPhone: any = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<any>(null);
  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch();
  const fetchLogin = useCallback(
    async (payload: { phone: string }) => {
      setLoading(true);
      loginSms(phoneFormat(payload.phone)!)
        .then((res) => {
          setSuccess(true);
          dispatch(authActions.checkPhoneSuccess());
        })
        .catch((e) => {
          enqueueSnackbar(
            `Ошибка: ${
              e?.response?.data?.status === 400
                ? 'Пользователя с указанным номером не существует'
                : getResponseMessage(e)
            }`,
            { variant: 'error' }
          );
        })
        .finally(() => {
          setLoading(false);
          setErr(null);
          setSuccess(false);
        });
    },
    [dispatch]
  );

  return [fetchLogin, loading, success];
};
